/**
 * Builds a query string from a record of params, omitting any value
 * that is null, undefined, or an empty string. Returns "" or "?...".
 *
 * Why this exists: services were building URLs with template literals
 * like `?sport=${sport}&page=${page}` which produces literal "undefined"
 * in the URL when a value is missing. URLSearchParams + this filter
 * makes that class of bug impossible.
 */
export type QueryValue = string | number | boolean | null | undefined;

export function buildQueryString(
  params: Record<string, QueryValue>,
): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) continue;
    if (typeof value === "string" && value.length === 0) continue;
    search.append(key, String(value));
  }
  const serialized = search.toString();
  return serialized.length > 0 ? `?${serialized}` : "";
}
